/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'favorite-add': {
    width: 39,
    height: 30,
    viewBox: '0 0 39 30',
    data: '<path pid="0" d="M16.8 0l4.5 10.43 11.5.986-8.692 7.471L26.723 30 16.8 24.083 6.877 30 9.53 18.887.8 11.416l11.5-.986L16.8 0zm18 19v4h4v3h-4v4h-3v-4h-4v-3h4v-4h3z" _fill="#000" fill-rule="nonzero"/>'
  }
})
